import React from 'react';
import DocOverlayWidget from '../doc-overlay/DocOverlayWidget';
import LegalLotExpWidget from '../LegalLotLineExpDemo/LegalLotExpWidget'
import { ThemeProvider } from "@mui/material/styles";
import { theme } from '../../../themes/MuiTheme';

const PopupDetailsWidget = ({view,layerIds,pageConfig}) => {
  return (
    <ThemeProvider theme={theme}>
      <DocOverlayWidget view={view} layerIds={layerIds}></DocOverlayWidget>
      </ThemeProvider>
  )
}

export default PopupDetailsWidget